import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {Typography} from 'antd';

declare const REACT_APP_BUILD_DATE: string;

export const AppVersionLayer: FC = () => {
  const {t} = useTranslation();
  return (
    <Typography.Text className="fixed bottom-0 right-8" type="secondary">
      {t('App build')}: {REACT_APP_BUILD_DATE}
    </Typography.Text>
  );
};
